
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/guides/ask-the-experts/page/[page]",
      function () {
        return require("private-next-pages/guides/ask-the-experts/page/[page].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/guides/ask-the-experts/page/[page]"])
      });
    }
  